import React from 'react';

// V70.49 — Bordrolarım / Belgelerim gibi henüz hazırlanmamış portal bölümleri için
// açık "yakında" sayfası. (Önceden bu rotalar HRDashboard render ediyordu —
// kullanıcı yanlış sayfaya düştüğünü sanıyordu.)
// V71 — inline sabit renkler yerine token'lı sınıflar (HRApp.css .hr-soon)
export default function HRComingSoon({ icon, title, description }) {
  return (
    <div className="hr-card hr-soon">
      <div className="hr-soon-ic">{icon}</div>
      <h2>{title}</h2>
      <p>{description}</p>
      <div className="hr-soon-badge">Yakında</div>
    </div>
  );
}
